module.exports = __webpack_public_path__ + "media/images/emblems/Chatillon-Blazono-e5d9225332cd3fb11e8087d2b766f2e4.png";